<template>
  <div class="layout">
    <Header class="header" title="分析" storeSelectable />
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/Header'
import Dialog from '@/components/molecules/ModalDialog'

/**
 * 分析画面のレイアウト
 */
export default {
  name: 'AnalysisLayout',
  components: {
    Header,
  },
  props: {
    /** カレントページキー */
    current: String,
  },
  created() {
    window.addEventListener('click', this.confirmDialog)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.confirmDialog)
  },
  methods: {
    async confirmDialog(e) {
      if (!this.$store.state.app.editing) return

      const target = e.target.closest('a')
      const isHash = target && target.getAttribute('href') === '#'
      if (!target || isHash) return
      e.preventDefault()
      e.stopPropagation()

      if (await Dialog.confirmLeaveSetting(this.$route.path)) {
        location.assign(e.target.href)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.body {
  display: flex;
  flex: 1;
  overflow: hidden;
}
</style>
